import { render, staticRenderFns } from "./InvoiceCarousel.vue?vue&type=template&id=5b5c418b&scoped=true&"
import script from "./InvoiceCarousel.vue?vue&type=script&lang=js&"
export * from "./InvoiceCarousel.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCarousel.vue?vue&type=style&index=0&id=5b5c418b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c418b",
  null
  
)

export default component.exports